
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import StudentLayout from './StudentLayout';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isStudent, loading } = useAuth();

  // Show a loading indicator while the authentication state is being resolved
  if (loading) {
    return (
      <div className="min-h-screen bg-[#0A0E1A] flex items-center justify-center">
        <div className="flex flex-col items-center gap-3">
          <div className="w-12 h-12 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin"></div>
          <p className="text-sm text-white/60">Carregando...</p>
        </div>
      </div>
    );
  }

  // If the user is not logged in, redirect to the student login page
  if (!isAuthenticated) {
    return <Navigate to="/login-aluno" replace />;
  }

  // If the logged‑in user is not a student, redirect to the admin area
  if (!isStudent) {
    return <Navigate to="/admin" replace />;
  }

  // All checks passed – render the protected content inside the student layout
  return <StudentLayout>{children}</StudentLayout>;
}
